/**
 * @param {string} html
 */
function makeDocument(html) {
  const parser = new DOMParser();

  return parser.parseFromString(html, 'text/html');
}


/**
 * @param {string} html
 */
function parseElementHtml(html) {
  const doc = makeDocument(html);

  return doc.body.firstChild;
}


/**
 * @param {string} html
 */
function stripHtmlTags(html) {
  const doc = makeDocument(html);

  return doc.body.textContent; 
}


function toggleBodyClass(className, isApplyingClass) {
  const classList = document.body.classList;
  if (isApplyingClass === true) {
    classList.add(className);
  } else {
    classList.remove(className);
  }
}


export {
  parseElementHtml,
  stripHtmlTags,
  toggleBodyClass,
};
